import React from "react";

const TermsOfUse = () => {
  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <h1>Términos y Condiciones de Uso</h1>
      <p>
        <strong>Última actualización:</strong> Abril 2025
      </p>

      <p>
        Bienvenido a <strong>MamboAdmin</strong>, un sistema diseñado para ayudarte a gestionar la facturación y administración de tu
        empresa de forma fácil, rápida y segura.
      </p>

      <h2>1. Quiénes somos</h2>
      <p>
        MamboAdmin es una plataforma desarrollada por GRUPO GUERRERO, S.A. DE C.V., dedicada a brindar herramientas tecnológicas para la
        gestión empresarial y contable.
      </p>

      <h2>2. Qué ofrecemos</h2>
      <p>
        MamboAdmin permite a las empresas emitir comprobantes electrónicos, registrar clientes, llevar control de ventas y mucho más. El
        servicio puede incluir funcionalidades adicionales sujetas a cambios y mejoras.
      </p>

      <h2>3. Registro y uso de la cuenta</h2>
      <ul>
        <li>Debés registrarte con información verdadera y actualizada.</li>
        <li>Al registrarte, se crea una cuenta de empresa vinculada a tu usuario.</li>
        <li>Sos responsable de mantener la confidencialidad de tus credenciales.</li>
      </ul>

      <h2>4. Responsabilidad del usuario</h2>
      <p>
        Te comprometés a usar el sistema de forma legal y responsable. No está permitido usar MamboAdmin para actividades fraudulentas o que
        violen derechos de terceros.
      </p>

      <h2>5. Privacidad y protección de datos</h2>
      <p>
        La información ingresada se utiliza para el funcionamiento del sistema. No compartimos tus datos sin tu consentimiento, salvo
        requerimiento legal. Consultá nuestra Política de Privacidad para más detalles.
      </p>

      <h2>6. Seguridad de la cuenta</h2>
      <p>
        Recomendamos el uso de contraseñas seguras y exclusivas para acceder al sistema. MamboAdmin no se hace responsable por accesos no
        autorizados debidos al uso compartido o negligente de las credenciales por parte del usuario.
      </p>

      <h2>7. Propiedad intelectual</h2>
      <p>
        El contenido, diseño, estructura y funcionalidades de MamboAdmin son propiedad de [Tu empresa] y están protegidos por leyes de
        propiedad intelectual. No está permitido copiar, modificar o distribuir ninguna parte del sistema sin autorización expresa.
      </p>

      <h2>8. Exportación y eliminación de datos</h2>
      <p>
        El usuario puede solicitar en cualquier momento la exportación o eliminación de sus datos personales o empresariales almacenados en
        el sistema. Para ello, deberá enviar una solicitud a <a href="mailto:soporte@mamboadmin.com">soporte@mamboadmin.com</a>.
      </p>

      <h2>9. Limitación de responsabilidad</h2>
      <p>
        MamboAdmin se proporciona "tal cual". No somos responsables por caídas temporales del sistema o pérdidas indirectas derivadas del
        uso del sistema.
      </p>

      <h2>10. Modificaciones</h2>
      <p>
        Nos reservamos el derecho de actualizar estos términos. Notificaremos cambios importantes a través de la plataforma o por correo
        electrónico.
      </p>

      <h2>11. Contacto</h2>
      <p>
        Si tenés dudas, escribinos a <a href="mailto:soporte@mamboadmin.com">soporte@mamboadmin.com</a>
      </p>

      <p>
        <strong>Al registrarte, aceptás estos Términos y Condiciones de uso.</strong>
      </p>
    </div>
  );
};

export default TermsOfUse;
